import { useEffect, useRef, useState } from 'react';
import { ComponentDimensions } from '../types/Layout';

export const useDimensions = () => {
  const [rootDimensions, setRootDimensions] = useState<
    ComponentDimensions | undefined
  >(undefined);
  const rootRef = useRef<any>(null);

  useEffect(() => {
    if (!!rootDimensions) {
      return;
    }

    if (!rootRef.current) {
      return;
    }

    setRootDimensions({
      height: rootRef.current.clientHeight,
      width: rootRef.current.clientWidth,
    });
  }, [rootDimensions]);

  return { dimensions: rootDimensions, ref: rootRef };
};
